import { gql } from "@apollo/client";

export const FETCH_AGENT_SESSION_IDS = gql`
    query FetchAgentSessionIds($brokerId: Int!) {
        fetchAgentSessionIds(broker_id: $brokerId) {
            success
            session_ids {
                id
                broker_id
                employee_id
                session_id
                session_title
                created_at
                updated_at
                broker_configuration {
                    broker_configuration_id
                    broker_company_name
                    broker_company_logo
                    broker_website
                }
                employee {
                    employee_id
                    employee_first_name
                    employee_last_name
                }
            }
        }
    }
`;
